module.exports = __webpack_public_path__ + "img/choose-action-bar-3.549eaed2.png";